module.exports = __webpack_public_path__ + "img/5817e5d.png";